"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSuggestions = fetchSuggestions;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _models = require("../../models");
async function fetchSuggestions(api, options) {
  const {
    searchText,
    top,
    country,
    pathKey
  } = options;
  const emptySuggestionsResponse = {
    addressSuggestionsCollection: []
  };
  if (!searchText) {
    return _models.FetchResult.errorFor(emptySuggestionsResponse);
  }
  const apiParams = {
    searchText,
    top,
    country,
    pathKey
  };
  try {
    const nodes = await (0, _globalApiClientReact.getAddressSuggestions)(api, apiParams);
    const result = new _models.FetchResult(nodes.status, nodes.data);
    return result;
  } catch (error) {
    return _models.FetchResult.errorFor(emptySuggestionsResponse);
  }
}
//# sourceMappingURL=useAddressSuggestionsQuery.js.map